/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DataClipId } from "../../commons/types/DataClipId";
import { SheetId } from "../../commons/types/SheetId";
import { ResolveTo } from "../../dataClips/types/ResolveTo";
import { RemovedFromMainResolution } from "../../dataClips/types/RemovedFromMainResolution";
export const UpdateDataClipResolutionsJobConfig = core.serialization.object({
    clipId: DataClipId,
    clippedSheetId: SheetId,
    resolveTo: ResolveTo,
    removedFromMainResolution: RemovedFromMainResolution,
    columnField: core.serialization.string(),
    columnValue: core.serialization.string(),
});
